import { createSlice } from "@reduxjs/toolkit";
import { returnee_applications } from "../../../types/returnee/returnee_application";

export const declinedReturneeApplications = createSlice({
  name: "declined_returnee_applications",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: returnee_applications;
      }[],
      data: [] as returnee_applications,
    },
  },
  reducers: {
    update_declined_returnee_applications: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload;
    },
    add_declined_returnee_application: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    addToDeclinedPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    remove_declined_returnee_application: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === Number(id)
      );

      if (currentIndex >= 0) {
        currentArray.splice(currentIndex, 1);
        state.value.data = currentArray;
      }
    },
    replace_declined_returnee_application: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_declined_returnee_applications: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_declined_returnee_applications,
  add_declined_returnee_application,
  addToDeclinedPaginationHistory,
  remove_declined_returnee_application,
  replace_declined_returnee_application,
  clear_declined_returnee_applications,
} = declinedReturneeApplications.actions;

export default declinedReturneeApplications.reducer;
